import { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Table } from '@dynamika-shared/ui/Table/Table';
import { useBreadcrumbs } from '@hooks/useBreadcrumbs';
import { SubjectListColumns } from './SubjectList.table.config';
import { useSubjectListFilters } from './useSubjectListFilters';
import { SubjectListFilters } from './SubjectListFilters';
import { SiteSubjectType } from '@restore/ValidationSpecialistSubjects/ValidationSpecialistSubjects.types';
import { routesPath } from '@router/routes';
import { useMakePagination } from '@restore/paginationAndSort/paginationAndSort.slice';
import { useSubjectListData } from '../hooks/useSubjectListData';

export const SubjectList = () => {
    const { clinicalTrialId } = useParams<{ clinicalTrialId: string }>();
    const navigate = useNavigate();
  
    const { onSort, onSearch, sortBy } = useSubjectListFilters();
  
    const {
      state,
      context,
    } = useSubjectListData({
      clinicalTrialId,
      onSearch,
    });
  
    useBreadcrumbs([['Validate List', 'validationSpecialistSubjectsClinicalTrial']], [clinicalTrialId]);
  
    const { data, loading } = state;
    const totalElements = data?.totalElements;
    const pagination = useMakePagination('validationSpecialistSubjects', !!totalElements);
  
    const handleRowClick = (subject: SiteSubjectType | number) => {
      if (typeof subject === 'number') return;
      // Navigate to subject detail page
      navigate(
        routesPath.validationSpecialistSubjectDetailClinicalTrial
          .replace(':clinicalTrialId', clinicalTrialId!)
          .replace(':patientId', subject.id)
      );
    };
  
  const columns = useMemo(
    () =>
      context?.clinicalTrialId
        ? SubjectListColumns(context.clinicalTrialId)
        : [],
    [context?.clinicalTrialId]
  );

  return (
    <>
      <div className='flex items-center justify-between py-3.5'>
        <h1>Validation List</h1>
      </div>
      <SubjectListFilters />
      <Table
        columns={columns}
        loading={loading}
        loadingLength={10}
        data={data?.content || []}
        pagination={pagination}
        totalItems={totalElements ?? 0}
        sortState={sortBy}
        onSort={onSort}
        onRowClick={handleRowClick}
      />
    </>
  );
};
